import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  id: 1,
  quote: "The attention to detail and level of service was beyond anything we've experienced. A truly unforgettable stay that redefined luxury for us.",
  name: 'Eleanor Richards',
  location: 'Stayed in Santorini'
}, {
  id: 2,
  quote: 'Finding the perfect villa for our family was seamless. The property exceeded the photos, and the concierge service made our trip effortless.',
  name: 'Marcus Chen',
  location: 'Stayed in Bali'
}, {
  id: 3,
  quote: 'An exquisite apartment in the heart of Paris. Waking up to those views and having every amenity at our fingertips was pure magic.',
  name: 'Sophia Laurent',
  location: 'Stayed in Paris'
}];
export function Testimonials() {
  return <section className="py-24 bg-white" data-id="element-246">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-247">
        <div className="text-center mb-16" data-id="element-248">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-4xl md:text-5xl font-italiana text-luxury-slate mb-4" data-id="element-249">
            What Our Guests Say
          </motion.h2>
          <motion.div initial={{
          opacity: 0,
          width: 0
        }} whileInView={{
          opacity: 1,
          width: '60px'
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="h-1 bg-luxury-blue mx-auto rounded-full" data-id="element-250" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-251">
          {testimonials.map((testimonial, index) => <motion.div key={testimonial.id} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.15
        }} className="bg-luxury-cream p-8 rounded-2xl shadow-sm border border-gray-100 flex flex-col h-full" data-id="element-252">
              <div className="flex space-x-1 mb-6" data-id="element-253">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-luxury-gold text-luxury-gold" data-id="element-254" />)}
              </div>

              <p className="text-gray-700 italic font-light leading-relaxed mb-8 flex-grow" data-id="element-255">
                "{testimonial.quote}"
              </p>

              <div className="mt-auto" data-id="element-256">
                <h4 className="font-semibold text-luxury-slate font-poppins" data-id="element-257">
                  {testimonial.name}
                </h4>
                <p className="text-sm text-gray-500 mt-1" data-id="element-258">
                  {testimonial.location}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}